




























import { Component, Vue, Ref } from 'vue-property-decorator';
import Order from '@/components/Invoicing/Order/Order.vue';
import { GQL_order_order } from '@/queries/__generated__/order';
import { SmartQuery } from 'vue-apollo-decorator';

import { GQL_orderNewData_currentUser } from '@/queries/__generated__/orderNewData';

import {
  newOrderObject,
  formDataToMutationInput,
  populateOrderWithUserNonChangeableSupplierInfo,
  populateOrderWithUserChangeableSupplierInfo,
  populateOurReference,
} from '@/app/Order';
import OrderNewControls from '@/components/Invoicing/Order/Controls/OrderNewControls.vue';

import { UnsavedChanges } from '@/decorators/unsaved-changes';
import { CREATE_ORDER, ORDER_NEW_DATA } from '../queries/Order';
import i18n from '@/i18n';
import DeepCopy from '@/decorators/deep-copy';

import unitInvoiceSettingsRequiredGuard from '@/guards/unit-invoice-settings-required-guard';
import checkSupplierMandatoryFieldsGuard from '@/guards/order-supplier-party-guard';

import VideoPopup, { ISnotrVideo } from '@/components/VideoPopup.vue';
import VideoTutorials from '@/app/VideoTutorials';

interface IMetadata {
  order: GQL_order_order;
}

@Component({
  components: {
    Order,
    OrderNewControls,
    VideoPopup,
  },
  beforeRouteEnter(to, from, next) {
    checkSupplierMandatoryFieldsGuard()
      .then(() => {
        unitInvoiceSettingsRequiredGuard(to, from, next);
      }).catch(router => {
        router.push({ name: 'Orders' });
        router.app.$sMessage.error(router.app.$t('Order.supplierPartyIsMissingInfo'), { duration: 0 });
      });
  },
})
export default class OrdersNew extends Vue {
  @SmartQuery({
    query: ORDER_NEW_DATA,
    fetchPolicy: "no-cache",
    result({ data }) {
      populateOrderWithUserNonChangeableSupplierInfo(this.formData.order, data.currentUser.currentUnit);
      populateOrderWithUserChangeableSupplierInfo(this.formData.order, data.currentUser.currentUnit);
      populateOurReference(this.formData.order.supplierParty, this.currentUser);
    },
  }) public currentUser!: GQL_orderNewData_currentUser;

  public data: IMetadata = { order: newOrderObject() as GQL_order_order };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @DeepCopy('data') private formData: any = null;

  public validForm = true;
  private formatData = formDataToMutationInput;
  private videos: ISnotrVideo[] = VideoTutorials;

  @UnsavedChanges<OrdersNew>({
    saveAndContinue() {
      return this.saveAndContinue();
    },
  }) public dirtyForm = false;

  @Ref() public readonly orderRef!: Order;

  private saveAndContinue() {
    return this.$apollo.mutate({
      mutation: CREATE_ORDER,
      variables: this.formatData(this.formData),
    }).then(() => {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      this.$sMessage.success(i18n.t('Message.saveSuccess'));
      return true;
    }).catch(() => {
      return false;
    });
  }

  private resetFormDirty() {
    this.orderRef.formRef?.resetDirty();
  }
}
